<script>
import { mapState } from 'vuex'
export default {
  name: 'Anchor',
  props: [
    'anchor',
    'zoom',
    'playing',
    'isSelected',
    'elapsed'
  ],
  computed: {
    ...mapState('access',[
      'options',
    ]),
    slug()      { return this.anchor.slug },
    name()      { return this.anchor.neyword },
    imgURL()    { return this.$apiURL + this.anchor.Animation.url },
    audioURL()  { return this.$apiURL + this.anchor.backgroundAudio.url },
    maxVolume() { return this.options.sound.value ? 0.4 : 0 },
  },

  data: () => ({
    distance: 0,
    maxDistance: 500,
  }),

  watch: {
    distance() {
      if (this.distance < this.maxDistance) {
        this.fade(
          this.$refs.audio, 
          this.$refs.audio.volume, 
          this.maxVolume * this.distance / this.maxDistance
        )
        // this.fade(this.$refs.audio.volume, 1 - (this.distance / this.maxDistance))
      } else {
        this.fade(
          this.$refs.audio, 
          this.$refs.audio.volume, 
          this.maxVolume
        )
        // this.fade(this.$refs.audio.volume, 0)
      }
      // console.log(this.slug, this.$refs.audio.volume)
    },
    playing() {
      if (this.$refs.audio) {
        if (this.playing) {
          this.play()
        } else {
          this.pause()
        }
      }
    },
  },

  mounted() {
    if (this.playing) {
      this.play()
    }
  },

  methods: {
    play() {
      this.fade(this.$refs.audio, this.$refs.audio.volume, this.maxVolume)
    },
    pause() {
      this.fade(this.$refs.audio, this.$refs.audio.volume, 0)
    },
    fade(audio, from, to) {
      const 
        direction = to > from,
        fadeout = setInterval(() => {
          if (direction && audio.paused) {
            audio.play()
          } 
          if ( direction ? to > from : from > to ) {
            from += direction ? 0.05 : -0.05
            if ( +direction ? from < +direction : from > +direction ) {
              audio.volume = from
            } else {
              audio.volume = +direction
            }
          } else {
            clearInterval(fadeout)
            if (!direction && !audio.paused && audio.volume == 0) {
              audio.pause()
            }
          }
        }, direction ? 300 : 100)
    },

  }

}
</script>

<template>
  <div 
    :class="['anchor', { isSelected: isSelected || options.showEverything.value }]"
    :style="{ '--zoom': zoom / 8 }"
    aria-label="An anchor on the map. Here exist some audio snippets."
    tabindex="-1"
  >
    <img 
      class="animation"
      :src="imgURL" 
    />
    <audio
      loop
      ref="audio"
      volume="0"
      :autoplay="playing"
      v-if="audioURL"
    >
      <source :src="audioURL" />
    </audio>
  </div>
</template>

<style scoped>

.anchor {
  position: relative;
  width: 100%;
  height: 100%;
  animation: fade var(--slow) ease;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(var(--zoom));
  transform-origin: center center;
  transition: transform var(--veryfast) ease;
  cursor: grab;
}

.anchor .animation {
  user-select: none;
  width: 100%;
}

.anchor .snippets {
  position: absolute;
  top: 50%;
  left: 50%;
  pointer-events: none;
}
.anchor.isSelected .snippets {
  pointer-events: all;
}

.isMobile .anchor {
  transform: scale(calc(var(--zoom)/2));
}

</style>
